import { SERVICE } from './constants'

export const PROCUREMENT = `${SERVICE}/PROCUREMENT`
export const PROCUREMENT_SUCCESS = `${SERVICE}/PROCUREMENT_SUCCESS`
export const PROCUREMENT_ERROR = `${SERVICE}/PROCUREMENT_ERROR`
export const SET_PROCUREMENT_INFORMATION = `${SERVICE}/SET_PROCUREMENT_INFORMATION`
export const RESET_PROCUREMENT_INFORMATION = `${SERVICE}/RESET_PROCUREMENT_INFORMATION`
